import { getPatientApiUrl } from "@/Utils/EnvUtils";
import {
  patientsWithUnhandledMeasurementsQueryOptions,
  useParentRoutesPatient,
} from "@/api/Patients";
import { Iframe } from "@medoma/components/Iframe/Iframe";
import { useQueryClient } from "@tanstack/react-query";
import { useUserProfile } from "@/api/Users";
import { useSelectedSite } from "@/Utils/useSelectedSite";
import { useLingui } from "@lingui/react/macro";

export const Measurements = () => {
  const { t } = useLingui();
  const queryClient = useQueryClient();
  const { organization } = useUserProfile();
  const patient = useParentRoutesPatient();
  const postMessageHandler = {
    messageType: "measurementAcknowledged",
    onMessageReceived: () => {
      void queryClient.invalidateQueries({
        queryKey: patientsWithUnhandledMeasurementsQueryOptions.queryKey,
      });
    },
  };

  const site = useSelectedSite();
  if (site === null) {
    throw new Error(
      "Should have selected site when showing patient measurements",
    );
  }

  return (
    <Iframe
      title={t`Mätvärden`}
      src={`${getPatientApiUrl(organization)}/htmx/center/${site}/patients/${patient.id}/measurements?react=true`}
      loadingMessage={t`Hämtar mätvärden`}
      padding={24}
      postMessageHandler={postMessageHandler}
    />
  );
};
